import { useEffect, useState } from 'react';
import * as signalR from '@microsoft/signalr';
import './App.css';
import { ITurno } from './models/turno';
import TurnoMain from './components/turno-main';
import { ITvMessage } from './models/tv-message';
import "react-image-gallery/styles/css/image-gallery.css";
import MdnPage from './components/mdn-page';
import DivriPage from './components/divri-page';
import AdminCarouselConfig from './components/AdminCarouselConfig';
import { HashRouter, Routes, Route } from 'react-router-dom';

const App = (): JSX.Element => {

  const [connection, setConnection] = useState<signalR.HubConnection>();
  const [isConnected, setIsConnected] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [connectionError, setConnectionError] = useState('');
  const [turnos, setTurnos] = useState<ITurno[]>([]);
  const [isCalling, setIsCalling] = useState(false);
  const [currentTurno, setCurrentTurno] = useState<ITurno | null>(null); 
  const [date, setDate] = useState('');
  const [client, setClient] = useState((window as any).domain);
  const [isProcessingQueue, setIsProcessingQueue] = useState(false);
  const [turnoIsCalling, setTurnoIsCalling] = useState<ITurno[]>([]);

  let callQueue: ITurno[] = [];
  let promiseQueue: Promise<void> = Promise.resolve();

  useEffect(() => {
    const id = setInterval(() => {
      setDate(new Date().toLocaleDateString() + '|' + new Date().toLocaleTimeString());
    }, 1000);

    return () => {
      clearInterval(id);
    }
  }, []);

  const showCall = (turno: ITurno): Promise<void> => {
    return new Promise((resolve) => {
      console.log("Inicio de turno", new Date().toLocaleTimeString());
      setIsCalling(true);
      setCurrentTurno(turno);
      const message = new SpeechSynthesisUtterance(turno.text);
      window.speechSynthesis.speak(message);

      setTimeout(() => {
        setIsCalling(false);
        setCurrentTurno(null);
        resolve();
        console.log("Fin de turno", new Date().toLocaleTimeString());
      }, 10000); 
    });
  };

  const enqueueProcessQueue = () => {
    promiseQueue = promiseQueue.then(() => processQueue());
  };

  const processQueue = async () => {
    if (callQueue.length > 0 && !isProcessingQueue) {
      setIsProcessingQueue(true);  
      console.log("Cola", callQueue.length);
      while (callQueue.length > 0) {
        const turno = callQueue.shift();
        console.log("Turno", turno);
        if (turno) {
          await showCall(turno);
        }
      }  
      setIsProcessingQueue(false);
    }
  };

  const onTurnosUpdate = (message: ITvMessage) => {
    console.log("onTurnosUpdate:", message);
    if (message != null) {
      const items = message.items || [];
      setTurnos(items);

      if (items.length > 0) {
        if (!message.silentMode) {
          const callingItems = items.filter(item => item.isCalling); // Filtra los turnos que tienen isCalling = true
          callQueue.push(...callingItems);
          setTurnoIsCalling(prev => [...prev, ...callingItems]);
          enqueueProcessQueue();
        }
      }
    }
  }

  const speak = (text: string) => {
    window.speechSynthesis.cancel();
  
    const utterance: SpeechSynthesisUtterance = new SpeechSynthesisUtterance(text);
  
    const loadVoices = () => {
      const voices = window.speechSynthesis.getVoices();
      const voice = voices.find(v => v.lang === 'es-ES');
  
      if (voice) {
        utterance.voice = voice; // ios required
        utterance.lang = voice.lang; // Android Chrome required
        // utterance.voiceURI = voice.voiceURI; // Removed as it does not exist on SpeechSynthesisUtterance
        utterance.pitch = 1;
        utterance.volume = 1;
        utterance.rate = 1;
        window.speechSynthesis.speak(utterance);
      } else {
        console.error("No hay voz cargada");
        playCallingSound();
      }
    };
  
    // Escuchar el evento voiceschanged si las voces aún no están cargadas
    if (window.speechSynthesis.getVoices().length === 0) {
      window.speechSynthesis.addEventListener('voiceschanged', loadVoices);
    } else {
      loadVoices(); // Ya están cargadas
    }
  }

  const playCallingSound = () => {
    const iframe = document.createElement('iframe');
    iframe.src = './calltoAttention.mp3';
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    // Eliminar el iframe después de 5 segundos
    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 5000);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paramValue = params.get('sucursal'); // Cambia 'myParam' por el nombre de tu parámetro
    const url = (window as any).masHub;

    if(paramValue !== null)
    {
      const connection = new signalR.HubConnectionBuilder().withUrl(`${url}/tv`).withAutomaticReconnect().build();
      setConnection(connection);

      connection.start().then(o => {
        setIsConnected(true);
        connection.on("OnTvConnected", () => setIsConnected(true));
        connection.on("OnTvConnected", () => setIsReady(true));
        connection.on('OnTurnosUpdate', onTurnosUpdate);
        connection.invoke('RegisterTV', paramValue);
      }).catch(ex => setConnectionError(ex));

      speak("Conectado");
      return () => {
        connection?.stop();
      };
    }

  }, []);

  return (
    <HashRouter>
      <Routes>
        <Route
          path="/"
          element={
            isConnected ? (
              isReady ? (
                <>
                  {client === "MDN" && <MdnPage turnos={turnos} date={date} />}
                  {client === "Divri" && (
                    <DivriPage turnos={turnos} date={date} client={client} currentTurno={currentTurno} />
                  )}
                  {isCalling && currentTurno && (
                    <TurnoMain key={currentTurno.id} turno={currentTurno} />
                  )}
                </>
              ) : (
                <div>
                  <h1>Cargando...</h1>
                </div>
              )
            ) : (
              <div>
                <h1>Desconectado</h1>
              </div>
            )
          }
        />
        <Route 
          path="/admin-carousel" 
          element={
            <div style={{ padding: '20px' }}>
              <h1>Administración del Carrusel</h1>
              <AdminCarouselConfig />
            </div>
          } 
        />
      </Routes>
    </HashRouter>
  );
};

export default App;
